import * as React from 'react'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image-es5'
import { FluidObject } from 'gatsby-image'
import { constants } from '../../constants'

interface Props {
  fluidImage1: FluidObject
  fluidImage2: FluidObject
  fluidImage3: FluidObject
  fluidImage4: FluidObject
  header?: () => JSX.Element
  contents: () => JSX.Element
}

const IngredientsKeyVisual: React.FC<Props> = ({
  header,
  contents,
  fluidImage1,
  fluidImage2,
  fluidImage3,
  fluidImage4,
}) => {
  return (
    <Wrapper>
      {header && <HeaderWrapper>{header()}</HeaderWrapper>}
      <StyledBg fluid={fluidImage1} />
      <StyledBg fluid={fluidImage2} />
      <Contents>
        <ContentsWrapper>{contents()}</ContentsWrapper>
      </Contents>
      <StyledBg fluid={fluidImage3} />
      <StyledBg fluid={fluidImage4} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  position: relative;
  height: 50vh;
  min-height: 350px;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    min-height: 760px;
    height: 100vh;
  }
`

const StyledBg = styled(BackgroundImage)`
  flex: 1;
`

const HeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`

const Contents = styled.div`
  flex: 0 0 200px;
  margin-top: ${constants.spacing.sp.medium};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    flex: 0 0 1004px;
    margin-top: ${constants.dimensions.headerHeight};
  }
`

const ContentsWrapper = styled.div`
  padding: 0 ${constants.spacing.sp.medium};

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    padding: 0 85px;
  }
`

export default IngredientsKeyVisual
